import { AbstractControl, UntypedFormGroup, Validators } from "@angular/forms";
import { MultiSessionLimitPeriod } from "@obg/ngx.ui.common";

import { NO_LIMIT } from "../responsible-gaming/deposit-limit/deposit-limit.const";

import { OBG_VALIDATORS } from "./validators";

export function multiSessionLimitAmountValidator(control: AbstractControl): {
	required?: boolean;
	numericNotZero?: boolean;
	numberSmallerOrEqual?: boolean;
} | null {
	if (control.parent) {
		const multiSessionLimitPeriodControl = (control.parent as UntypedFormGroup).controls.sessionLimitPeriod;

		if (
			multiSessionLimitPeriodControl &&
			!Validators.required(multiSessionLimitPeriodControl) &&
			multiSessionLimitPeriodControl.value !== NO_LIMIT.value
		) {
			const multiSessionLimitPeriod = multiSessionLimitPeriodControl.value;
			const periodText = MultiSessionLimitPeriod[multiSessionLimitPeriod];
			const maxLimit = multiSessionLimitPeriod * 24;

			const validations = [
				{ error: Validators.required(control), result: { required: true } },
				{ error: OBG_VALIDATORS.numericNotZero(control), result: { numericNotZero: true } },
				{
					error: OBG_VALIDATORS.numberSmallerOrEqual(maxLimit)(control) && periodText,
					result: { [`${periodText.toLowerCase()}.numberSmallerOrEqual`]: true },
				},
			];

			for (const validation of validations) {
				if (validation.error) {
					return validation.result;
				}
			}

			return null;
		}
	}

	return (
		Validators.required(control) ||
		OBG_VALIDATORS.numericNotZero(control) ||
		OBG_VALIDATORS.numberSmallerOrEqual(720)(control)
	);
}
